import ImagesZoom from 'components/pages/community/ImagesZoom';
import React, { useState } from 'react';
import styled from 'styled-components';
import theme from 'styles/theme';
import { Column, Row, Text } from 'components/pages/market/home/MarketItem';
import ArrowRightSvg from "assets/icons/keyboard_arrow_right.svg";


function MarketInfoTabView({ info }) {
   const SALES_INFO_TITLE = '영업정보';
   const SALES_TIME_SUBTITLE = '영업시간';
   const FLOWER_COMING_DATE_SUBTITLE = '꽃들어오는날';
   const HOLIDAY_SUBTITLE = '휴무일';
   const MARKET_INTRO_TITLE = '가게소개';
   const PLACE_TITLE = '위치';
   const ZOOM_TEXT = '확대보기';

   const [isOpenZoom, setOpenZoom] = useState(false);
   const openZoom = () => setOpenZoom(true);
   const closeZoom = () => setOpenZoom(false);

   if (!info) {
      return <></>;
   }
   return (
      <MarketInfoTabViewWrap>
         <InfoSection>
            <SectionTitle>{SALES_INFO_TITLE}</SectionTitle>
            <SalesInfoWrap>
               <SalesInfoRow>
                  <InfoKey>{SALES_TIME_SUBTITLE}</InfoKey>
                  {/* 하드코딩요청 */}
                  <InfoValue>{'0시 ~ 13시(공휴일 낮 12시)'}</InfoValue>
               </SalesInfoRow>
               <SalesInfoRow>
                  <InfoKey>{FLOWER_COMING_DATE_SUBTITLE}</InfoKey>
                  <InfoValue>{'월 · 수 · 금'}</InfoValue>
               </SalesInfoRow>
               <SalesInfoRow>
                  <InfoKey>{HOLIDAY_SUBTITLE}</InfoKey>
                  <InfoValue>{'일요일'}</InfoValue>
               </SalesInfoRow>
            </SalesInfoWrap>
         </InfoSection>

         <InfoSection>
            <SectionTitle>{MARKET_INTRO_TITLE}</SectionTitle>
            <MarketIntroduction>{info.wholeIntro}</MarketIntroduction>
         </InfoSection>

         <InfoSection>
            <PlaceSectionTitle>
               <Row>
                  <SectionTitle>{PLACE_TITLE}</SectionTitle>
                  <Text>{info.whole_loc}</Text>
               </Row>

               <ZoomBtn onClick={openZoom}>
                  <Row>
                     {ZOOM_TEXT}
                     <ArrowIcon src={ArrowRightSvg}/>
                  </Row>
               </ZoomBtn>
            </PlaceSectionTitle>
            <PlaceImg src={info.locImg} alt={'map'} onClick={openZoom}/>
         </InfoSection>

         {isOpenZoom && <ImagesZoom images={[info.locImg]} onClose={closeZoom} />}
      </MarketInfoTabViewWrap>
   );
}

export default MarketInfoTabView;

// common
const MarketInfoTabViewWrap = styled.div`
   background-color: ${theme.color.white};
`;

const InfoSection = styled.section`
   padding: 24px 16px;
   border-bottom: 1px solid ${theme.color.gray100};
`;

export const SectionTitle = styled.p`
   font-weight: 700;
   font-size: 16px;
   line-height: 24px;
   margin-bottom: 16px;
`;

// 영업정보
const SalesInfoWrap = styled(Column)`
   gap: 8px;
`;
const InfoKey = styled.div``;
const InfoValue = styled.div``;
const SalesInfoRow = styled(Row)`
   font-weight: 400;
   font-size: 14px;
   line-height: 20px;
   ${InfoKey} {
      width: 35%;
      color: ${theme.color.gray600};
   }
   ${InfoValue} {
      width: 65%;
   }
`;

// 가게소개
const MarketIntroduction = styled.div`
   font-weight: 400;
   font-size: 14px;
   line-height: 20px;
`;

// 위치
const ZoomBtn = styled.button`
   cursor: pointer;
   display: flex;
   flex-direction: row;
   align-items: center;
   font-weight: 400;
   font-size: 12px;
   line-height: 20px;
   border: none;
   background-color: ${theme.color.white};
   height: fit-content;
   color: ${theme.color.gray600};
`;
const PlaceSectionTitle = styled(Row)`
   justify-content: space-between;
   margin-bottom: 16px;

   ${SectionTitle} {
      display: inline-flex;
      align-items: center;
      margin: 0px;
   }

   ${Text} {
      margin-left: 7px;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      color: ${theme.color.gray900};
   }
`;

const PlaceImg = styled.img`
   object-fit: contain;
   width: 100%;
`;

const ArrowIcon = styled.img`
   width : 21px;
   height : 21px;
`